module.exports = __webpack_public_path__ + "static/media/campo5.b721a5d7.jpg";